export default "__VITE_ASSET__eb74ea5c__"